import { UberConferenceServiceComponent } from './UberConferenceServiceComponent';
export const UberconferenceReconnectionConfig = {
  serviceComponent: UberConferenceServiceComponent
};